import HTTPService from '../HTTPService'
import PrepareDataForMessage from './PrepareDataForMessage'

class Message extends PrepareDataForMessage {

  send (companySlug, clientId, payload) {
    const prepareData = this.prepareData(payload)
    return HTTPService.post(`company/${companySlug}/client/${clientId}/message`, prepareData)
  }
}

export default new Message()
